<template>
  <div class="step-progress" :class="{ 'theme-light' : theme }">
      <ul>
        <li class="active"><span>Import</span></li>
        <li :class="{ active : progress > 0 }"><span>Traitement</span></li>
        <li :class="{ active : progress > 1 }"><span>Résultats</span></li>
      </ul>
    </div>
</template>

<script>
export default {
  name: 'StepProgress',
  props: {
    progress: {
      type: Number,
      default: 0
    },
    theme: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
  .step-progress {
    display: flex;
    justify-content: center;
  }

  .step-progress ul {
    list-style: none;
    padding-left: 0;
    display: flex;
    margin-top: 2rem;
  }

  .step-progress li {
    font-size: .75rem;
    font-weight: 500;
    color: var(--white);
    position: relative;
    width: .75rem;
    height: .75rem;
    border-radius: 50%;
    background-color: var(--white);
  }

  .step-progress.theme-light li {
    color: var(--text-black);
  }

  .step-progress li span {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 1.5rem;
  }

  .step-progress li + li {
    margin-left: 8rem;
  }

  .step-progress li.active {
    background-color: var(--naega-green);
  }

  .step-progress li::after {
    content: '';
    position: absolute;
    width: calc(8rem + .375rem);
    height: 2px;
    background-color: var(--white);
    right: 50%;
    transform: translateY(50%);
    bottom: 50%;
  }

  .step-progress li.active::after {
    background-color: var(--naega-green);
  }

  .step-progress li:first-child::after {
    content: none;
  }
</style>
